import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Ebl extends mixins(GraphRanges) {
  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("graph", patientNamespace)
  graph!: any;

  get charts(): MultiChartConfig[] {
    return [
      {
        data: this.graph([{ key: "EBL", label: "QBL" }]),
        suggestedMax: 1000
      }
    ];
  }
}
